import { render, staticRenderFns } from "./Inquery.vue?vue&type=template&id=beae843c&scoped=true&"
import script from "./Inquery.vue?vue&type=script&lang=js&"
export * from "./Inquery.vue?vue&type=script&lang=js&"
import style0 from "./Inquery.vue?vue&type=style&index=0&id=beae843c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beae843c",
  null
  
)

component.options.__file = "Inquery.vue"
export default component.exports